import { render, staticRenderFns } from "./PlcSetting.vue?vue&type=template&id=976702e4&"
import script from "./PlcSetting.vue?vue&type=script&lang=js&"
export * from "./PlcSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports